// PR-I-85: pantalla member para publicar/editar su expertise.
// Reusa ExpertiseForm (mismo componente que usa la vista admin), envuelto en el
// contenedor tap-host para respetar el layout PROFILE (header + sidebar + footer).
// UserProfileContext ya esta montado en Routes.tsx a nivel raiz, asi que el form
// lee data.expertise del user logueado sin necesidad de setSearchParams (userSelected
// vacio => /full-profile/ hace fallback al request.user, y updateUserExpertise sin
// memberId apunta a /profile/expertise/ del propio member).

import {FC, useEffect, useRef} from 'react'
import {useLayout} from '../../../_metronic/layout/core'
import ExpertiseForm from './components/ExpertiseForm'

const EditExpertisePage: FC = () => {
  const {config, setLayout} = useLayout()
  const restoreRef = useRef(config)

  useEffect(() => {
    restoreRef.current = config
    setLayout({
      ...config,
      header: {...config.header, display: true},
      aside: {...config.aside, display: true},
      toolbar: {...config.toolbar, display: false},
      footer: {...config.footer, display: true},
    })
    return () => setLayout(restoreRef.current)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div className='tap-host-wrapper'>
      <div className='tap-host-container'>
        <ExpertiseForm />
      </div>
    </div>
  )
}

export {EditExpertisePage}
export default EditExpertisePage
